<template>
  <div class="flex flex-col h-screen bg-slate-50">
    <AppHeader></AppHeader>
    <div class="flex flex-col flex-1 overflow-y-auto">
      <UContainer class="mt-8 pb-24">
        <slot />
      </UContainer>
    </div>
  </div>
</template>

<script setup lang="ts"></script>

<style scoped></style>
